import { z } from 'zod';

export const AppEnvironmentPropertySchema = z.object({
  id: z.string(),
  value: z.string(),
});

export const AppEnvironmentSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  properties: z.array(AppEnvironmentPropertySchema),
});

export const AppSummary = z.object({
  appId: z.string().optional(),
  appName: z.string().nullish(),
  version: z.string().nullish(),
  updatedAt: z.string().nullish(),
  colorIcon: z.string().nullish(),
  manifestVersion: z.string().optional(),
  teamsAppId: z.string(),
  environments: z.array(AppEnvironmentSchema).nullable(),
});

export type IAppSummary = z.infer<typeof AppSummary>;